import type { SettingsOptions } from "@/common/types/settingsOptions";
import axiosClient from "@/lib/axios/axiosClient";

export const getSettingsOptions = async (): Promise<SettingsOptions> => {
  const response = await axiosClient.get<SettingsOptions>("/settings/options", {
    sendToken: true,
    headers: {
      Accept: "application/json",
      "Content-Type": "text/plain; charset=utf-8",
    },
  });
  return response.data;
};
